import { CSSObject, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTranslation } from 'react-i18next';

import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    textAlign: 'left',
});
interface Props {
    children: string | null | undefined;
    maxNumberOfWords?: number;
    style: CSSObject | SerializedStyles;
    buttonStyle?: CSSObject | SerializedStyles;
}

export const ExpandableText: React.FC<Props> = ({
    children,
    maxNumberOfWords = 20,
    style,
    buttonStyle,
}) => {
    const [expanded, setExpanded] = useState(false);
    const words = (children || '').split(' ');
    const textTooLong = words.length > maxNumberOfWords;
    const { t } = useTranslation();
    const actionButtonText = expanded ? t('common.show_less') : t('common.read_more');
    const text =
        textTooLong && !expanded ? `${words.slice(0, maxNumberOfWords).join(' ')}...` : children;

    const actionButtonHandler = () => {
        setExpanded(!expanded);
    };

    const Text = styled.p(style);

    const buttonStyles = buttonStyle || {
        color: color.royalBlue,
        cursor: 'pointer',
        ...font.heavy(font.size.base),
    };

    const ActionButton = styled.p(buttonStyles);

    return (
        <>
            <Wrapper
                css={{
                    opacity: expanded ? 0 : 1,
                    height: expanded ? 0 : 'auto',
                    overflow: expanded ? 'hidden' : 'auto',
                }}
            >
                <Text>{text}</Text>
                {textTooLong ? (
                    <ActionButton onClick={actionButtonHandler}>{actionButtonText}</ActionButton>
                ) : null}
            </Wrapper>
            <AnimateHeight
                style={{ opacity: expanded ? 1 : 0, textAlign: 'left' }}
                height={expanded ? 'auto' : 0}
                duration={200}
            >
                <Text>{children}</Text>
                {textTooLong ? (
                    <ActionButton onClick={actionButtonHandler}>{actionButtonText}</ActionButton>
                ) : null}
            </AnimateHeight>
        </>
    );
};
